import './index.css';
import { AuthPlugin } from 'auth-plugin';
import { CheckoutPlugin } from 'checkout-plugin';
import { LanguagePlugin } from 'language-plugin';
import { LocationPlugin } from 'location-plugin';
import { MenuPlugin } from 'menu-plugin';

import { MyCheckApp, MYCHECK_APP, injector } from 'mycheck-core';

import 'react-virtualized/styles.css';

const initApplication = async (publishableKey: string) => {
  fetch(
    process.env.NODE_ENV === 'development'
      ? '/configuration/dine/v1/devConfiguration.json'
      : '/configuration/dine/v1/configuration.json',
  )
    .then((response) => response.json())

    .then(async (config) => {
      const app = new MyCheckApp({
        plugins: [
          new AuthPlugin(),
          new LanguagePlugin(),
          new LocationPlugin(),
          new MenuPlugin(),
          new CheckoutPlugin(),
        ],
      });
      injector.set(MYCHECK_APP, app);

      await app.init(publishableKey, config);

      app.render();
    })

    .catch(async (error) => {
      console.error('An error occurred', error);
    });
};

window.initPickupV3 = initApplication;
